import { SynopsisObject } from "../../components/menu/menuContent/data.types";
import { Dispatch, SetStateAction } from "react";

export enum MenuContentOptions {
  NAVIGATION = "navigation",
  TRAILER = "trailer",
  SYNOPSIS = "synopsis",
  CAST_CREW = "castcrew",
}

export interface MenuContextType {
  isMenuOpen: boolean;
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>;
  menuBg: string;
  setMenuBg: Dispatch<SetStateAction<string>>;
  menuContent: MenuContentOptions;
  setMenuContent: Dispatch<SetStateAction<MenuContentOptions>>;
}

export interface MenuProps {
  synopsisData: SynopsisObject;
  buyTicketsLink: string;
  trailerLink: string;
}
